import { getI18n } from "react-i18next";

export function formatTimestamp(timestamp: number) {
  const i18n = getI18n();
  const date = new Date(timestamp * 1000);
  return date.toLocaleString(i18n.language);
}
